import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23ff38e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 추정시가총액 "),
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 직전 기관투자가치 또는 시중 거래호가, 언론 또는 증권사에서 평가하고 있는 시가총액입니다. 데이터는 제공처의 주관적인 의견이 포함되어 있으니 참고용으로 활용해주세요! ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { translucent: true }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}